(() => {
  const script = document.currentScript;
  const searchPath = new URL(script.dataset.searchUrl, location.origin).pathname;
  const words = text => text.match(/[\p{L}\p{N}]+/gu) || [];
  const titleQuery = text => words(text).map(word => 'title:' + word + '*').join(' AND ');
  const readTitleQuery = query => {
    if (!/^(?:title:[\p{L}\p{N}]+\*)(?: AND title:[\p{L}\p{N}]+\*)*$/u.test(query)) return query;
    return [...query.matchAll(/title:([\p{L}\p{N}]+)\*/gu)].map(match => match[1]).join(' ');
  };
  const current = new URL(location.href);
  const isSearchPage = current.pathname.replace(/\/$/, '') === searchPath.replace(/\/$/, '');
  const query = current.searchParams.get('q') || '';
  const readable = current.searchParams.get('frame_style') ?? readTitleQuery(query);
  const targetFor = (text, base) => {
    const url = new URL(base || searchPath, location.origin);
    url.searchParams.set('q', titleQuery(text));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    if (text.trim()) url.searchParams.set('frame_style', text.trim());
    else url.searchParams.delete('frame_style');
    url.searchParams.delete('page');
    return url;
  };
  if (isSearchPage && query.trim()) {
    const corrected = targetFor(readable, current);
    if (corrected.searchParams.get('q') !== query || current.searchParams.get('type') !== 'product') {
      location.replace(corrected.href);
      return;
    }
  }
  const restoreLabel = () => {
    if (!isSearchPage) return;
    document.querySelectorAll('input.search-page-input[name="q"]').forEach(input => {
      if (input.value === query || input.value === readTitleQuery(query)) input.value = readable;
    });
  };
  restoreLabel();
  document.addEventListener('DOMContentLoaded', restoreLabel, { once: true });
  document.addEventListener('shopify:section:load', restoreLabel);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || action.pathname !== searchPath) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = targetFor(input.value, action);
    for (const [name, value] of new FormData(form)) {
      if (!['q', 'type', 'options[prefix]', 'frame_style', 'page'].includes(name)) url.searchParams.append(name, value);
    }
    location.assign(url.href);
  }, true);
})();
